'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import ProductListingPage from 'components/consumer/ProductListingPage';
import useClearancePageData from './hooks/useClearancePageData';

// The hook-bearing half. `useClearancePageData` runs the legacy `getClearance`
// resolver (live Caravel calls) for the user's zip, so it may only mount on
// the consumer path — never in the admin preview below.
const ClearanceProductListing = () => {
  const $ = _c(4);
  const pageData = useClearancePageData();
  let t0;
  if ($[0] !== pageData) {
    t0 = {
      ...pageData,
      layout: "minimal-with-attributes"
    };
    $[0] = pageData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const pageDataWithLayout = t0;
  let t1;
  if ($[2] !== pageDataWithLayout) {
    t1 = <ProductListingPage pageData={pageDataWithLayout} serverOwnsSeoTags={true} />;
    $[2] = pageDataWithLayout;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};

// The admin variant builder mounts CMS components for preview. The live grid
// is zip-dependent and its query runs the legacy resolver, so — like
// ConsumerFlashsalePage — render a placeholder there instead. The split
// matters: a hook called in this component would run before the `isAdmin`
// branch and fire the query for admin previews too.
const ConsumerClearancePage = t0 => {
  const $ = _c(2);
  const {
    isAdmin
  } = t0;
  if (isAdmin) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="w-full p-12 border border-gray text-center"><p>Clearance page component. The clearance product grid will display correctly in Consumer.</p></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ClearanceProductListing />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ConsumerClearancePage;